import { TrpcURL } from './trpc-url';

export const getTrpcUrl = ({ baseURL }: { baseURL: string }) => {
  const url = new URL(`${baseURL}/${TrpcURL.fullPath}`);
  return url.toString();
};
